import {CommentEntity} from './CommentEntity.js'
import {CommentIdEntity} from './CommentIdEntity.js'

export class ReviewsEntitiesFactory {
  static commentEntity = ({id, author, text, date, answers}) => new CommentEntity({id, author, text, date, answers})

  static commentIdEntity = ({id}) => new CommentIdEntity({id})
}
